module.exports = __webpack_public_path__ + "img/1155768511.61475ceb.jpg";